import { SvgIcon } from '@mui/material';

export const IconBurgerMenu = () => (
  <SvgIcon width="26" height="26" viewBox="0 0 26 26">
    <line y1="-1" x2="21.3333" y2="-1" transform="matrix(-1 0 0 1 26.6667 9.33334)" stroke="#002D59" strokeWidth="2" />
    <line y1="-1" x2="10.6667" y2="-1" transform="matrix(-1 0 0 1 16 25.3333)" stroke="#002D59" strokeWidth="2" />
    <line y1="-1" x2="21.3333" y2="-1" transform="matrix(-1 0 0 1 26.6667 17.3333)" stroke="#002D59" strokeWidth="2" />
  </SvgIcon>
);
